export { ElearningDetailHero } from "./hero";
export { ElearningDetailCourse } from "./detail";
